import { Link } from 'react-router-dom';

export default function AboutCtaSection() {
  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20lush%20green%20tropical%20botanical%20garden%20with%20sunlight%20filtering%20through%20leaves%2C%20rich%20emerald%20green%20foliage%20background%2C%20health%20nature%20wellness%20theme%2C%20beautiful%20natural%20scene&width=1920&height=600&seq=about-cta-bg-01&orientation=landscape"
          alt="CTA 背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#1a3a1a]/82" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
        <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-6">
          開始合作
        </span>
        <h2 className="text-white font-bold leading-tight mb-6">
          準備好讓康永成為<br />您的代工夥伴了嗎？
        </h2>
        <p className="text-green-200 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto mb-10">
          不論您是新創品牌或成熟企業，康永生技都能提供最適合您需求的代工解決方案，歡迎聯絡我們的業務團隊。
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/contact/form"
            className="whitespace-nowrap bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
          >
            立即諮詢
          </Link>
          <Link
            to="/partnership"
            className="whitespace-nowrap bg-white/15 hover:bg-white/25 border border-white/60 text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
          >
            了解合作流程
          </Link>
        </div>
      </div>
    </section>
  );
}
